/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('bookInfo', function () {
        return {
            scope: { },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/bookinfo/bookinfo.view.html',
            controller: ["$scope", "DocumentModel", "DocumentService", "NetworkService", function ($scope, DocumentModel, DocumentService, NetworkService) {
                var scope = $scope;

                scope.bookCoverSrc = false;

                DocumentModel.subscribe.onModelUpdate(function(){
                    var bookInfo = DocumentModel.getDocumentBaseInformation();
                    scope.bookCoverSrc = bookInfo.covers[0][0].path;
                    scope.authors = bookInfo.authors.join(', ');
                    scope.position = bookInfo.position;
                    scope.title = bookInfo.title;
                    scope.bookInfo = bookInfo.description || '';
                    scope.switchLike = function() {
                        DocumentService.updateFavorite(!scope.like);
                        NetworkService.updateBookOffset(DocumentService.getCurrentChapterOffsetObject()).then(function(){
                            scope.like = !scope.like;
                        });
                    };

                    document.title = scope.authors + " \"" + scope.title+ "\""

                    DocumentService.subscribe.onProgressUpdate(function(params) {
                        scope.progress = (100 *params.pages.current / params.pages.total).toFixed(0);
                        scope.progressWidth = scope.progress + '%';
                    });
                });

            }]
        };
    });